import { gql } from '@apollo/client';

export const AssetFragment = gql`
  fragment asset on Asset {
    type
    url
    contentType
  }
`;
